import React, { Component } from 'react'
import { connect } from 'react-redux'
import PlayersReport from './statistics/PlayersReport'
import PlayersStats from './statistics/PlayersStats'
import TeamsStats from './statistics/TeamsStats'
import QuestionsStats from './statistics/QuestionsStats'
import PollsStats from './statistics/PollsStats'
import './styles.css'

class Statistics extends Component {
  render () {
    return (
      <div className='main-col-cell' style={{ maxHeight: 'none' }}>
        <div className='dashboard-teams'>
          <div className='headline'>
            <h4>Statistics / Reports</h4>
          </div>
          <div className='y-scroll-wrap'>
            <div className='y-scroll'>
              <div className='dashboard-teams-list'>
                <PlayersStats />
                <TeamsStats />
                <PlayersReport />
                <QuestionsStats />
                <PollsStats />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

export default connect(mapStateToProps)(Statistics)



// WEBPACK FOOTER //
// ./src/screens/administration/Statistics.js